/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "view-order-collection",
	props:{
		orderId:{
			default: null
		},
		orderCollectionId: {
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderDispensed: {},
			orderGrandTotal: 0,
			billingAddress:null,
			shippingAddress: null,
			reasonsForDeliveryFailure: [],
			deliveryProcessFeatureFlags: {},
			orderVehicle: {},
			totalForOrder: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			dateOfCompletion:{
				value: new Date(),
				errorMessage: null,
				hasError: false,
				initialiseDate: true
			},
			orderItemsHasError: false,
			orderItemsErrorMessage: null,
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			documentsModal:{
				modalId: "orderDocumentsModal",
				heading: "Order Documents",
				showModal: false,
				orderId: null,
				orderTypeId: null
			},
			orderItemsDispensed: [],
			cancelOrderModalId: "cancelOrderModal",
			markAsOnDeliveryModalId: "markAsOnDeliveryModal",
			cancelOrderScheduledForDeliveryModalId: "cancelOrderScheduledForDeliveryModal",
			completeOrderConfirmationModalId: "completeOrderConfirmationModal",
			orderStatus: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getOrderForCollection(){
			this.loading = true;
			this.orderStatus = orderHelper.orderStatus;
			this.order = {
				orderId: 1,
				companyId: 1,
				orderStatusId: 1,
				insertedOn: "2021-01-01",
				depotId: 1,
				totalAmount: 100,
				billingAddressId: 14,
				registeredCompanyName: "Test Company",
				depot: "Test Depot",
				orderType: "Collection",
				vehicle: "Test Vehicle",
				vehicleId: 1,
				orderCollectionId: 1,
				orderTypeId: 2,
				collectionCode: "",
				manifestNumber: "231331",
				fleetNumber: "323233",
				odometerReading: 12000
			};
			this.loading = false;
			
		},
		getOrder(){
			this.loading = true;
			this.orderStatus = orderHelper.orderStatus;
			console.log("orderStatus", this.orderStatus);
			orderService.getCollectionOrder(this.orderCollectionId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.order = dataTableHelper.castObjectValues(this.order);
						this.order.totalAsString = currencyHelper.numberToCurrency(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrency(this.orderGrandTotal);
						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCompanyVehicle();
						//this.getCustomerShippingAddresses();
						this.getCustomerBillingAddress();
						this.getOrderDispensed();
						//this.getReasonsForDeliveryFailure();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompanyVehicle(){
			let request = {
				vehicleId: this.order.vehicleId
			};
			customerService.getCompanyVehicle(request).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderVehicle = successResponse.data.result;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderDispensed(){
			this.loading = true;
			orderService.getOrderDispensedForOrder(this.order.orderId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.result === null){
							this.orderDispensed = {};
						}
						else{
							this.orderDispensed = successResponse.data.result;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		},
		downloadOrderAsPdf(){
			orderService.getOrderCollectionAsPdf(this.orderId, this.orderCollectionId);
		},
		onCancelOrderClick(){
			$("#" + this.cancelOrderModalId).modal("show");
		},
		onCancelYesClick(){
			this.cancelOrder();
		},
		viewTrackingHistory() {
			this.trackingHistoryModal.showModal = true;
			this.trackingHistoryModal.orderId = this.order.orderId;
			this.trackingHistoryModal.heading = "Tracking History - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
		},
		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		cancelOrder() {
			this.loading = true;
			let request = {
				orderId: this.order.orderId,
				orderCollectionId: this.orderCollectionId,
				companyId: this.order.companyId
			};
			orderService.cancelCollectionOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					this.loading = false;
					if(isSuccess){
						$("#" + this.cancelOrderModalId).modal("hide");
						this.$router.go(-1);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDateOfCompletionSelect(date){
			console.log(date);
			this.dateOfCompletion.value = date;
			this.dateOfCompletion.initialiseDate = false;
		},
		onDispenseUpdate(orderItems){
			this.orderItemsDispensed = orderItems;
		},
		completeOrder(){
			// this.loading = true;
			// let request = {
			// 	orderId: this.order.orderId,
			// 	companyId: this.order.companyId,
			// 	isOverride: true,
			// 	orderDispensedItems: this.orderItemsDispensed,
			// 	dateOfCompletion: this.dateOfCompletion.value
			// };
			// orderService.completeDeliveryOrder(request).then(
			// 	successResponse => {
			// 		this.loading = false;
			// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
			// 		if(isSuccess){
			// 			if(successResponse.data.completeOrderValidationResponse.valuesAreValid){
			// 				$("#" + this.completeOrderConfirmationModalId).modal("hide");
			// 				this.$router.go(-1);
			// 			}
			// 			else{
			// 				this.orderItemsHasError = successResponse.data.completeOrderValidationResponse.orderItemsDispensedValidationResponse.hasError;
			// 				this.orderItemsErrorMessage = successResponse.data.completeOrderValidationResponse.orderItemsDispensedValidationResponse.message;
			//				
			// 				this.dateOfCompletion.hasError = successResponse.data.completeOrderValidationResponse.dateOfCompletionValidationResponse.hasError;
			// 				this.dateOfCompletion.errorMessage = successResponse.data.completeOrderValidationResponse.dateOfCompletionValidationResponse.message;
			//				
			// 			}
			// 		}
			// 	},
			// 	errorResponse => {
			// 		console.log("error", errorResponse);
			// 		this.loading = false;
			// 		apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
			// 	}
			// );
				
		},
		setBreadcrumbs() {
			let pageTitle = "View Order - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		},
		getDeliveryProcessFeatureFlags(){
			settingsService.getDeliveryProcessFeatureFlags().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.deliveryProcessFeatureFlags = successResponse.data.result;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		viewOrderDocuments(){
			this.documentsModal.showModal = true;
			this.documentsModal.orderId = this.order.orderId;
			this.documentsModal.heading = "Order Documents - #" + this.order.orderId;
			this.documentsModal.orderTypeId = orderHelper.orderType.collection;
		},
		onDocumentsModalClose(){
			this.documentsModal.showModal = false;
			this.documentsModal.orderId = null;
		}
	},
	mounted: function () {
		//this.setBreadcrumbs();
		// this.getProvinces();
		// this.getShippingAreas();
		// this.getShippingZones();
		//this.getDeliveryProcessFeatureFlags();
	},
	watch:{
		orderCollectionId:{
			handler: function () {
				console.log("orderCollectionId", this.orderCollectionId);
				if (this.orderCollectionId !== null && this.orderCollectionId > 0) {
					this.getOrder();
				}
			},
			immediate: true,
			deep: true
		}
	}
};